import React, { useState,useRef }  from 'react'
import Loader from './Loader'
import md5 from '../md5';
import {loaddat,localestr} from '../utils'
import packageInfo from '../../package.json'
//import label from '../label.svg' 
import logo from '../logo.svg' 


  //import './header.css'

  //тут би ще дописати переключатель мов

function AuthForm({status,inUser,loginData,setLogin}){
    let defUser=''
    const targetRef = useRef()

    if (status==='UsrChoise') if (loginData.users.length>0) {
        defUser=loginData.users[0].name;
        for (let i=0;i<loginData.users.length;i++){
            if (loginData.users[i].name===inUser) {
                defUser=inUser
                break
            }
        } 
    }

    const [Loading, setLoading] = useState(false)
    const [User, setUser] = useState('')
    const [Pass, setPass] = useState('')
    const prog_id=loginData.prog_id||['']

    

    function changeHandler(data,setLogin) {
        setLoading(true)
        setLogin({status:'setPass',pass:Pass})
        loaddat("action=init&data="+JSON.stringify(data),(d)=>{setLoading(false);setLogin(d)})
    }

    function changeUser(data){
        setUser(data)
    }

    function changePass(data){
        if (data) setPass(md5(data))
    }

    function setFocus(el){
        if (!el) return
        el.focus()
    }
    
    if (Loading) return <Loader />
    if (status==='UsrChoise'){
        let usr=User
        if (usr==='') usr=defUser
        return <div style={{top: '0', width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <table className='form login-form'><tbody>
            <tr><td colSpan={2} style={{border:'none',paddingBottom:'16px'}}>
                <img style={{width:'85px',marginRight:'10px',marginTop:'2px'}} align='left' src={logo} alt=''/>
                {/*<img style={{width:'74px',marginRight:'10px',marginTop:'2px'}} align='left' src='logo512.png' alt=''/>*/}
                {/*<span style={{fontWeight:'bold'}}>Coctail</span><br />
                <span><img style={{height:'25px'}} src={label} alt=''/></span><br />*/}
                <span style={{fontWeight:'bold'}}>back office</span><br />
                <span style={{fontSize:'small'}}>{localestr('Версія')}: standard {packageInfo.version}</span><br />
                <span style={{fontSize:'small'}}>{localestr('с/н')}: {prog_id}</span><br />
               
            </td></tr>
            <tr><td style={{border:'none'}}><label htmlFor="name">{localestr('Користувач')}: </label></td><td style={{border:'none'}}>
           <select id="name" defaultValue={usr} onChange={(e)=>{changeUser(e.target.value)}} style={{width: '170px'}}>
                {loginData.users.map((item)=>{ return <option value={item.name} key={item.name}>{item.name}</option>})}
            </select></td></tr>
            <tr><td style={{border:'none'}}><label htmlFor="pass">{localestr('Пароль')}: </label></td><td style={{border:'none'}}>
            <input id="pass" type='password' ref={el=>{setFocus(el);return targetRef}} onKeyUp={(e)=>{if(e.key === 'Enter') changeHandler({user:usr,pass:Pass},setLogin) }}  
            onChange={(e)=>{changePass(e.target.value)}} style={{width: '162px'}}/></td></tr>
            <tr><td colSpan='2' style={{textAlign:'center', border:'none',paddingTop:'16px'}}><div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{changeHandler({user:usr,pass:Pass},setLogin)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div></td></tr>
            {/*<tr><td colSpan='2' style={{textAlign:'center', border:'none'}}><button type='submit' onClick={()=>{changeHandler({user:usr,pass:Pass},setLogin)}}>&nbsp; OK &nbsp;</button></td></tr>*/}
            </tbody></table></div>
    } else {
        return <div>{localestr('Помилка авторизації!')}</div>
    }

}

export default AuthForm

